import { ClientContext, log } from "@limitless/common/utils";

/**
 * All clients to control LLMs visiblity via window object
 *
 * @param {object} appVisibility
 * @param {fucntion} toggleAppVisibility
 * @param {function} openApp
 */
export const createLLMWindowObject = (appVisibility, toggleAppVisibility, openApp, switchCardSet) => {
    window.LLM = {
        ...window.LLM,
        set visible(val) {
            ClientContext._appVisible = val;
            if (val === true) {
                openApp();
            }

            if (val === false) {
                toggleAppVisibility(false);
            }
        },
        get visible() {
            return appVisibility.isAppVisible;
        },
        set loglevel(inputVal) {
            const val = inputVal.toLowerCase();
            if (
                val === "debug" ||
                val === "trace" ||
                val === "info" ||
                val === "warn" ||
                val === "silent" ||
                val === "error"
            ) {
                log.warn(`Setting Log Level to ${val}`);
                log.setLevel(val);
            }
        },
        get loglevel() {
            return log.getLevel();
        },
        show() {
            toggleAppVisibility(true);
        },
        switchCardSet(options) {
            if (typeof options?.cardSetId === "number") {
                switchCardSet(options.cardSetId);
            } else {
                //restore the default card set
                switchCardSet("");
            }
        }
    };
};

export const createExpertReachOut = createExpertExperience => {
    if (window.LLM) {
        window.LLM.createExpertReachOutExperience = params => {
            return createExpertExperience(params);
        };
    } else {
        window.LLM = {
            createExpertReachOutExperience(params) {
                return createExpertExperience(params);
            }
        };
    }
};

export const createStaticReachOut = createStaticExperience => {
    if (window.LLM) {
        window.LLM.createStaticReachOutExperience = params => {
            return createStaticExperience(params);
        };
    } else {
        window.LLM = {
            createStaticReachOutExperience(params) {
                return createStaticExperience(params);
            }
        };
    }
    // window.LLM = {
    //     ...window.LLM,
    //     createStaticReachOutExperience(params) {
    //         return createStaticExperience(params);
    //     }
    // };
};
